import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { OrdenCompraComponent } from './orden-compra.component';
import { AddOrdenCompraComponent } from './add-orden-compra/add-orden-compra.component';
import { ListarOrdenCompraComponent } from './listar-orden-compra/listar-orden-compra.component';
import { AuthGuard } from '../services/guards/login-guard.guard';

const routes: Routes = [
  { path: '', canActivate: [AuthGuard], component: OrdenCompraComponent },
  { path: 'add-orden-compra', canActivate: [AuthGuard], component: AddOrdenCompraComponent },
  { path: 'listar-orden-compra', canActivate: [AuthGuard], component: ListarOrdenCompraComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class OrdenCompraRoutingModule { }
